var React = require('react');

function OrangeTriangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0H8L4 5L0 0Z","fill":"#FF5F00"}));
}

OrangeTriangle.defaultProps = {"width":"8","height":"5","viewBox":"0 0 8 5","fill":"none"};

module.exports = OrangeTriangle;

OrangeTriangle.default = OrangeTriangle;
